import React from 'react';
import { Box, Typography, TextField, Button, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

export const OtherMaterials = ({ value = [], onChange, editMode = false }) => {
  if (editMode) {
    const handleAddMaterial = () => {
      onChange('otherMaterials', [...value, '']);
    };

    const handleChange = (index, newValue) => {
      const newMaterials = [...value];
      newMaterials[index] = newValue;
      onChange('otherMaterials', newMaterials);
    };

    const handleRemove = (index) => {
      const newMaterials = value.filter((_, i) => i !== index);
      onChange('otherMaterials', newMaterials);
    };

    return (
      <Box my={2}>
        <Typography variant="h6" gutterBottom>Other Materials</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1, mb: 1 }}>
          Include any other materials needed such as cable needle, stitch markers, tapestry needle, etc.
        </Typography>
        {value && value.map((material, index) => (
          <Box key={index} display="flex" alignItems="center">
            <TextField
              value={material || ''}
              onChange={(e) => handleChange(index, e.target.value)}
              fullWidth
              placeholder="e.g., Stitch markers, tapestry needle, cable needle"
              margin="dense"
              size="small"
            />
            <IconButton 
              color="error" 
              onClick={() => handleRemove(index)}
              sx={{ ml: 1 }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
        <Button 
          variant="outlined" 
          startIcon={<AddIcon />} 
          onClick={handleAddMaterial}
          sx={{ mt: 1 }}
        >
          Add Material
        </Button>
      </Box>
    );
  }

  if (!value || value.length === 0) return null;

  return (
    <>
      {value.map((material, index) => (
        <Typography key={index}>{material}</Typography>
      ))}
    </>
  );
};

export default OtherMaterials;
